// extracted by mini-css-extract-plugin
module.exports = {"logo":"tech-module--logo--25YUS","large":"tech-module--large--1C3TY","list":"tech-module--list--BIynx","listWrapper":"tech-module--listWrapper--ggobk"};